module.exports = __webpack_public_path__ + "static/media/21ECLAC12.1ec818a7.jpg";